<template>
  <div class="top-box">
    <div class="container top">
      <span>917.cn 资源共享平台</span>
      <div class="auth-box">
          <span>欢迎来到 917.cn 资源共享平台</span>
          <template v-if="!isLogin">
            <router-link :to="{name: 'register'}" class="reg">[免费注册]</router-link>
            <router-link :to="{name: 'login'}" class="reg">[登陆]</router-link>
          </template>
          <template v-else>
            <router-link :to="{name: 'assets-list'}" class="reg">[用户中心]</router-link>
            <span class="reg" @click="onLogout">退出</span>
          </template>
          
          <span class="contact" v-if="false">联系客服</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import commonMixin from '@/mixin/common'
export default {
  name: 'Top',
  mixins: [commonMixin],
  computed: {
    ...mapGetters('auth', ['isLogin'])
  },
  methods: {
    ...mapActions('auth', ['AUTH_LOGOUT']),
    onLogout() {
      this.AUTH_LOGOUT().then(res => {
        if (res.code === 200) {
          this.success('退出成功')
        } else {
          this.warning(res.message)
        }
      }).catch(err => {
        console.log('err', err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top-box { 
  height: 35px;
  line-height: 35px;
  border-bottom: solid 1px #eeeeee;
  color: #666;
  font-size: 13px;
  .top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .reg {
      cursor: pointer;
      color: #009900;
      margin-left: 10px;
      text-decoration: none;
    }
    .login {
      color: #0088cc;
    }
    .contact {
      margin-left: 10px;
    }
  }
}

</style>